import { useCallback, useState } from './core.js';
export function useList(initialList = []) {
    const [list, setList] = useState(initialList);
    const push = useCallback((item) => setList(_ => [..._, item]), []);
    const pop = useCallback(() => setList(_ => _.slice(0, -1)), []);
    const remove = useCallback((item) => setList(_ => _.filter(currentItem => currentItem !== item)), []);
    const clear = useCallback(() => setList([]), []);
    return [list, { setList, push, pop, remove, clear }];
}
